import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import toolsService from '../services/toolsService';
import { queryKeys } from './queryKeys';

export function useTools(toolType = 'user_created', options = {}) {
  return useQuery({
    queryKey: queryKeys.tools.all,
    queryFn: () => toolsService.getAllTools(toolType),
    staleTime: Infinity,
    ...options,
  });
}

export function useAdminTools(options = {}) {
  return useQuery({
    queryKey: queryKeys.tools.admin,
    queryFn: () => toolsService.getAllTools('admin_created'),
    staleTime: Infinity,
    ...options,
  });
}

export function useDeleteTool(options = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: id => toolsService.deleteTool(id),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.tools.all });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
}

export function useCreateTool(options = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload => toolsService.createTool(payload),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.tools.all });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
}

export function useUpdateTool(options = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload => toolsService.updateTool(payload),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.tools.all });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
}
